/* ========== GPO radio rozetleri (Ausgebucht / Freie Plätze) — anında yaz ========= */
(function () {
  const ROOT_SELECTOR = '.gpo-ov-wrapper';
  const RADIO_SELECTOR = '.gpo-choicelist.gpo-radio input[type="radio"]';
  const BADGE_CLASS = 'gpo-seat-badge';

  // Tek input'u güncelle
  function updateOne(input) {
    if (!input || input.type !== 'radio') return;

    const holder = input.closest('.gpo-choicelist');
    const label  = holder && holder.querySelector('label');
    if (!holder || !label) return;

    // Rozeti .choicelist-item__value içine koy (yoksa label'a)
    let badge = label.querySelector('.' + BADGE_CLASS);
    if (!badge) {
    badge = document.createElement('span');
    badge.className = BADGE_CLASS;
    label.appendChild(badge);
    }

    const isSoldOut =
      input.disabled === true ||
      input.hasAttribute('disabled') ||
      input.getAttribute('data-unavailable') === 'true';

    if (isSoldOut) {
      badge.textContent = 'Ausgebucht';
      badge.dataset.status = 'soldout';
      holder.classList.add('is-soldout');
      holder.classList.remove('is-free');
    } else {
      badge.textContent = 'Freie Plätze';
      badge.dataset.status = 'free';
      holder.classList.add('is-free');
      holder.classList.remove('is-soldout');
    }
  }

  // Kök altında tüm radio'ları güncelle
  function updateAll(root) {
    (root || document).querySelectorAll(RADIO_SELECTOR).forEach(updateOne);
  }

  // GPO DOM’u geç geldiği için: body seviyesinde izleyici
  function initObservers() {
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes') {
          const t = m.target;
          if (t.matches && t.matches(RADIO_SELECTOR)) updateOne(t);
        }
        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            // Yeni wrapper ya da içeriği geldiyse hemen tara
            if (node.matches?.(ROOT_SELECTOR) || node.querySelector?.(RADIO_SELECTOR)) {
              updateAll(node);
            }
          });
        }
      }
    });

    // tüm sayfayı izle (GPO yeniden render ettiğinde de yakalar)
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'data-unavailable']
    });
  }

  function kick(root) { updateAll(root || document); }

  // İlk yükleme + farklı muhtemel tetikleyiciler
  document.addEventListener('DOMContentLoaded', () => { kick(); initObservers(); });
  window.addEventListener('load', () => kick());
  // Tema editörü
  document.addEventListener('shopify:section:load', (e) => kick(e.target));
  // GPO bazı temalarda bu event'leri atar; yoksa zararı yok
  ['gpo:init','gpo:updated','gpo:changed'].forEach(evt =>
    document.addEventListener(evt, () => kick())
  );
  // Kullanıcı etkileşimi
  document.addEventListener('change', (e) => {
    if (e.target?.matches(RADIO_SELECTOR)) updateOne(e.target);
  });
})();




// Custom.js — 3 öğe göster, "mehr anzeigen / weniger anzeigen" ile aç/kapa
(function () {
  const CLIP_HEIGHT = 236; // px
  const MORE_LABEL = '+ mehr anzeigen';
  const LESS_LABEL = '- weniger anzeigen'; // isterseniz 'weniger anzeigen'

  // Hangi wrapper'ları izleyeceğiz?
  const WRAPPER_SELECTORS = ['.gpo-ov-wrapper', '.crs-radio-list'];

  // GPO hedef input adları (sadece bu gruplara uygula)
  const TARGET_INPUT_NAMES = ['Vorbereitungskurs', 'Telc-Prüfungstermin'];

  // Stil
  const style = document.createElement('style');
  style.textContent = `
    .gpo-ov-wrapper, .crs-radio-list { transition: max-height .3s ease; }
    .gpo-ov-toggle-btn {
      display:inline-block; margin:8px 0 0; padding:8px 12px;
      border:1px solid #ddd; background:#fff; border-radius:6px;
      font-size:14px; cursor:pointer;
    }
    .gpo-ov-toggle-btn:focus { outline:2px solid #005bd3; outline-offset:2px; }
  `;
  document.head.appendChild(style);

  function collapse(el) {
    el.style.maxHeight = CLIP_HEIGHT + 'px';
    el.style.height = 'auto';
    el.style.overflow = 'hidden';
  }

  function expand(el) {
    // İçerik artarsa tekrar çağırmak için güvenli
    el.style.maxHeight = el.scrollHeight + 'px';
    el.style.height = 'auto';
    el.style.overflow = 'visible';
  }

  function getItems(wrapper) {
    if (wrapper.classList.contains('gpo-ov-wrapper')) {
      // Globo item'ları
      return wrapper.querySelectorAll('.gpo-choicelist.gpo-radio.gpo-ov-item.is-free, .gpo-choicelist.gpo-radio.gpo-ov-item');
    }
    if (wrapper.classList.contains('crs-radio-list')) {
      // Kurs item'ları
      return wrapper.querySelectorAll('.crs-radio-row');
    }
    return [];
  }

  function isTargetGroup(wrapper) {
    if (wrapper.classList.contains('gpo-ov-wrapper')) {
      // GPO'da sadece belirli input adları
      return TARGET_INPUT_NAMES.some((n) =>
        wrapper.querySelector(`input[name="${CSS.escape(n)}"]`)
      );
    }
    if (wrapper.classList.contains('crs-radio-list')) {
      // Kurs listesinde herhangi bir radio varsa uygula
      return !!wrapper.querySelector('input[type="radio"]');
    }
    return false;
  }

  function enhanceGroup(wrapper) {
    if (wrapper.dataset.gpoToggleReady === '1') {
      // Eğer geniş açık ise ve içerik değiştiyse maxHeight'i güncelle
      const btn = wrapper.nextElementSibling;
      if (btn && btn.classList && btn.classList.contains('gpo-ov-toggle-btn') && btn.getAttribute('aria-expanded') === 'true') {
        expand(wrapper);
      }
      return;
    }

    if (!isTargetGroup(wrapper)) return;

    const items = getItems(wrapper);
    if (items.length <= 3) return;

    wrapper.dataset.gpoToggleReady = '1';
    collapse(wrapper);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gpo-ov-toggle-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = MORE_LABEL;

    wrapper.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        collapse(wrapper);
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = MORE_LABEL;
      } else {
        expand(wrapper);
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = LESS_LABEL;
      }
    });
  }

  function scan() {
    WRAPPER_SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach(enhanceGroup);
    });
  }

  // İlk kurulum
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);

  // Dinamik DOM değişiklikleri için gözlemci
  const mo = new MutationObserver((mutations) => {
    let shouldScan = false;
    for (const m of mutations) {
      if ((m.addedNodes && m.addedNodes.length) || (m.type === 'attributes')) {
        shouldScan = true; break;
      }
    }
    if (shouldScan) requestAnimationFrame(scan);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: false });
})();



/* Eski tarih gizleme (sistem tarihinden eski olan tüm tarihleri gizler)
   + Seçilen kurs tarihine göre Telc-Prüfungstermin filtreleme (varsa)
   Desteklenen yapılar:
   - CXN pills: label.cxn-pill > input[data-date="DD.MM.YYYY"]
   - CRS: .crs-radio-row / .crs-radio-title
   - GPO: .gpo-choicelist (exam radios)
*/
(function () {
  "use strict";

  // ------------------ Ortak yardımcılar ------------------
  const DATE_RE = /(\d{2}\.\d{2}\.\d{4})/; // DD.MM.YYYY
  const HIDE_CLASS = "aw-past-date-hidden";
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function ensureHideStyle() {
    if (document.getElementById("aw-past-date-style")) return;
    const st = document.createElement("style");
    st.id = "aw-past-date-style";
    st.textContent = `.${HIDE_CLASS}{display:none !important;}`;
    document.head.appendChild(st);
  }

  function parseDateDDMMYYYY(text) {
    const m = String(text || "").match(DATE_RE);
    if (!m) return null;
    const [d, mo, y] = m[1].split(".").map(Number);
    const dt = new Date(y, mo - 1, d);
    dt.setHours(0, 0, 0, 0);
    return dt;
  }

  function today0() {
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  }

  function addDays(dt, days) {
    const d = new Date(dt.getTime());
    d.setDate(d.getDate() + days);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function hide(el) {
    if (!el) return;
    el.classList.add(HIDE_CLASS);
    el.setAttribute("aria-hidden", "true");
  }
  function show(el) {
    if (!el) return;
    el.classList.remove(HIDE_CLASS);
    el.removeAttribute("aria-hidden");
  }
  function isHidden(el) {
    return !!(el && el.classList && el.classList.contains(HIDE_CLASS));
  }

  // ------------------ Haftalık hesap ------------------
  // ISO haftası: Pazartesi=1..Pazar=7
  function isoDay(dt) { return ((dt.getDay() + 6) % 7) + 1; }
  function startOfISOWeek(dt) { return addDays(dt, 1 - isoDay(dt)); }
  // Seçilen Pazartesi için SONRAKİ haftanın Cumartesisi
  function nextWeekSaturdayFrom(dt) { return addDays(startOfISOWeek(dt), 12); }

  // ================== A) CXN PILL (senin HTML) ==================
  function getCxnDateRadios() {
    // Örnek: <label class="cxn-pill"><input type="radio" data-date="12.01.2026"></label>
    return qsa('label.cxn-pill input[type="radio"][data-date]');
  }
  function cxnRowOf(radio) {
    return radio?.closest("label.cxn-pill") || radio?.closest("label") || null;
  }
  function cxnDateOf(radio) {
    return parseDateDDMMYYYY(radio?.dataset?.date || radio?.value || "");
  }

  function pruneOldDates_CXN() {
    const radios = getCxnDateRadios();
    if (!radios.length) return;

    const t0 = today0();

    radios.forEach((r) => {
      const row = cxnRowOf(r);
      const d = cxnDateOf(r);
      if (!row || !d) return;

      if (d < t0) {
        hide(row);
        if (r.checked) r.checked = false;
      } else {
        show(row);
      }
    });

    // Seçili görünür yoksa ilk görünürü seç (mümkünse disabled olmayan)
    const hasCheckedVisible = radios.some((r) => r.checked && !isHidden(cxnRowOf(r)));
    if (!hasCheckedVisible) {
      const visible = radios.filter((r) => !isHidden(cxnRowOf(r)));
      const pick = visible.find((r) => !r.disabled) || visible[0];
      if (pick) {
        pick.checked = true;
        pick.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  // ================== B) CRS (.crs-*) yapı (varsa) ==================
  function getCrsDateRadios() {
    const g1 = document.querySelector('.crs-opt[data-option-index="1"]') || document;
    return qsa(".crs-radio-list input[type='radio']", g1);
  }
  function crsRowOf(radio) {
    return radio?.closest(".crs-radio-row") || null;
  }
  function crsDateOf(radio) {
    const row = crsRowOf(radio);
    const txt = row?.querySelector(".crs-radio-title")?.textContent || radio?.value || "";
    return parseDateDDMMYYYY(txt);
  }

  function pruneOldDates_CRS() {
    const radios = getCrsDateRadios();
    if (!radios.length) return;

    const t0 = today0();

    radios.forEach((r) => {
      const row = crsRowOf(r);
      const d = crsDateOf(r);
      if (!row || !d) return;

      if (d < t0) {
        hide(row);
        if (r.checked) r.checked = false;
      } else {
        show(row);
      }
    });

    const hasCheckedVisible = radios.some((r) => r.checked && !isHidden(crsRowOf(r)));
    if (!hasCheckedVisible) {
      const visible = radios.filter((r) => !isHidden(crsRowOf(r)));
      const pick = visible.find((r) => !r.disabled) || visible[0];
      if (pick) {
        pick.checked = true;
        pick.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  // ================== C) GPO exam (varsa) ==================
  function getExamRadios() {
    return qsa('input[type="radio"][name="Telc-Prüfungstermin"]');
  }
  function examRowOf(radio) { return radio?.closest(".gpo-choicelist") || null; }
  function examDateOf(radio) {
    const row = examRowOf(radio);
    return parseDateDDMMYYYY(row?.textContent || radio?.value || "");
  }

  // Crash date kaynağı: önce CXN, yoksa CRS
  function getCrashRadios() {
    const cxn = getCxnDateRadios();
    if (cxn.length) return cxn;
    return getCrsDateRadios();
  }
  function crashDateOf(radio) {
    if (radio?.dataset?.date) return parseDateDDMMYYYY(radio.dataset.date);
    // CRS fallback
    return crsDateOf(radio) || parseDateDDMMYYYY(radio?.value || "");
  }

  // Crashkurs seçimine göre sınavları filtrele ve otomatik seç
  function filterAndSelectExamByCrashkurs(forcePick = false) {
    const crash = getCrashRadios().find((r) => r.checked);
    const examRadios = getExamRadios();
    if (!crash || !examRadios.length) return;

    const crashDate = crashDateOf(crash);
    if (!crashDate) return;

    const t0 = today0();
    const minExam = nextWeekSaturdayFrom(crashDate);

    let firstVisible = null;
    let exactMin = null;

    examRadios.forEach((r) => {
      const row = examRowOf(r);
      const d = examDateOf(r);
      if (!row || !d) return;

      // ✅ hem geçmiş tarihleri gizle hem de minExam kuralını uygula
      if (d < t0 || d < minExam) {
        hide(row);
        if (r.checked) r.checked = false;
      } else {
        show(row);
        if (!firstVisible) firstVisible = r;
        if (d.getTime() === minExam.getTime()) exactMin = r;
      }
    });

    const selectedExam = examRadios.find((r) => r.checked);
    const selectedVisible = selectedExam && !isHidden(examRowOf(selectedExam));

    if (forcePick || !selectedVisible) {
      const pick = exactMin || firstVisible;
      if (pick) {
        pick.checked = true;
        pick.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  // ================== Event bağlama (tek sefer) ==================
  function bindOnce() {
    // Crash radios (CXN/CRS)
    getCrashRadios().forEach((r) => {
      if (r.dataset.dateMgmtBound === "1") return;
      r.dataset.dateMgmtBound = "1";

      r.addEventListener("change", () => {
        if (r.checked) {
          // crash değişince exam’i yeniden filtrele
          filterAndSelectExamByCrashkurs(true);
        }
      });
    });
  }

  // ================== INIT + Observer ==================
  let initLock = false;
  function init() {
    if (initLock) return;
    initLock = true;

    try {
      ensureHideStyle();

      // 1) önce geçmiş tarihleri gizle
      pruneOldDates_CXN();
      pruneOldDates_CRS();

      // 2) sonra exam filtrele (varsa)
      filterAndSelectExamByCrashkurs(false);

      // 3) event bind
      bindOnce();
    } catch (e) {
      console.error("[custom.js] Tarih yönetimi hatası:", e);
    } finally {
      initLock = false;
    }
  }

  const mo = new MutationObserver((muts) => {
    const changed = muts.some((m) =>
      Array.from(m.addedNodes || []).some((n) => {
        if (n.nodeType !== 1) return false;
        return (
          n.matches?.("label.cxn-pill, .crs-radio-row, .crs-radio-list, .gpo-choicelist, .gpo-form__group") ||
          n.querySelector?.("label.cxn-pill, .crs-radio-row, .crs-radio-list, .gpo-choicelist, .gpo-form__group")
        );
      })
    );
    if (changed) {
      clearTimeout(mo._t);
      mo._t = setTimeout(init, 80);
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    init();
    mo.observe(document.body, { childList: true, subtree: true });
    // bazı temalarda seçenekler geç basılıyor
    setTimeout(init, 250);
    setTimeout(init, 900);
  });

  window.addEventListener("load", () => init());
})();

/* codex-b1-intensivkurs-date-fix-v3 */
(function(){
  if (window.__codexB1IntensivDateFixV3Loaded) return;
  window.__codexB1IntensivDateFixV3Loaded = true;
  if (!/\/products\/b1-intensivkurs(?:$|[/?#])/.test(window.location.pathname + window.location.search + window.location.hash)) return;
  var EXAM_HANDLE = 'telc-b1-allgemein';
  var OFFSET_DAYS = 12;
  var DATE_MARKER = 'data-codex-b1-intensiv-date-fixed';
  var variants = [];
  var rendering = false;
  var scheduled = null;

  function parseDMY(text){
    var m = String(text || '').match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
    if(!m) return null;
    var d = new Date(+m[3], +m[2] - 1, +m[1]);
    return isNaN(d) ? null : d;
  }
  function parseLastDMY(text){
    var matches = Array.from(String(text || '').matchAll(/(\d{1,2})\.(\d{1,2})\.(\d{4})/g));
    var m = matches.length ? matches[matches.length - 1] : null;
    if(!m) return null;
    var d = new Date(+m[3], +m[2] - 1, +m[1]);
    return isNaN(d) ? null : d;
  }
  function addDays(date, days){ var d = new Date(date.getTime()); d.setDate(d.getDate() + days); return d; }
  function escapeAttr(value){ return String(value || '').replace(/"/g, '&quot;'); }
  function root(){ return document.getElementById('course-exam-enroller'); }
  function ui(rootEl){ return rootEl && rootEl.querySelector('#cxn-exam-ui'); }
  function selectedCourseDate(rootEl){
    var selected = rootEl.querySelector('input[name="cxn_course_variant"]:checked') || rootEl.querySelector('input[name="cxn_course_variant"]');
    return selected ? selected.getAttribute('data-date') : '';
  }
  function minExamDate(rootEl){
    var end = parseLastDMY(selectedCourseDate(rootEl));
    return end ? addDays(end, OFFSET_DAYS) : null;
  }
  function filteredDates(rootEl){
    var min = minExamDate(rootEl);
    var all = Array.from(new Set(variants.map(function(v){ return v.option1; }).filter(Boolean))).sort(function(a,b){
      var da = parseDMY(a), db = parseDMY(b);
      return da && db ? da - db : 0;
    });
    return min ? all.filter(function(date){ var d = parseDMY(date); return d && d >= min; }) : all;
  }
  function anyAvailableOnDate(date){ return variants.some(function(v){ return v.option1 === date && v.available; }); }
  function anyAvailableForType(date, type){ return variants.some(function(v){ return v.option1 === date && v.option2 === type && v.available; }); }
  function ensureHolder(rootEl){
    var holder = rootEl.querySelector('#cxn-exam-variants-json');
    if(!holder){
      holder = document.createElement('script');
      holder.type = 'application/json';
      holder.id = 'cxn-exam-variants-json';
      rootEl.appendChild(holder);
    }
    holder.textContent = JSON.stringify(variants);
  }
  function ensureDateField(rootEl){
    var area = ui(rootEl);
    if(!area) return null;
    var dateFS = area.querySelector('#cxn-exam-date');
    if(!dateFS){
      dateFS = document.createElement('fieldset');
      dateFS.className = 'cxn-fieldset';
      dateFS.id = 'cxn-exam-date';
      dateFS.setAttribute('data-required', '1');
      dateFS.setAttribute('aria-disabled', 'false');
      dateFS.innerHTML = '<legend>3) Prüfungstermin wählen</legend><div class="cxn-collapsible" data-collapsed="true" style="max-height:245px"><div class="cxn-pill-list" role="radiogroup" aria-label="Prüfungstermin" data-exam-opt="1"></div></div><button type="button" class="cxn-toggle">+ Mehr anzeigen</button>';
      var typeFS = area.querySelector('#cxn-exam-type');
      if(typeFS) area.insertBefore(dateFS, typeFS); else area.insertBefore(dateFS, area.firstChild);
    }
    return dateFS;
  }
  function ensureTypeField(rootEl){
    var area = ui(rootEl);
    if(!area) return;
    var typeFS = area.querySelector('#cxn-exam-type');
    var types = Array.from(new Set(variants.map(function(v){ return v.option2; }).filter(Boolean)));
    if(!typeFS && types.length){
      typeFS = document.createElement('fieldset');
      typeFS.className = 'cxn-fieldset';
      typeFS.id = 'cxn-exam-type';
      typeFS.setAttribute('data-required', '1');
      typeFS.setAttribute('aria-disabled', 'true');
      typeFS.innerHTML = '<legend>4) Prüfungsart</legend><div class="cxn-pill-list" role="radiogroup" aria-label="Prüfungsart" data-exam-opt="2"></div>';
      area.appendChild(typeFS);
    }
    var group = typeFS && typeFS.querySelector('[data-exam-opt="2"]');
    if(group && !group.querySelector('input[name="cxn_exam_opt2"]') && types.length){
      group.innerHTML = types.map(function(type){
        return '<label class="cxn-pill"><input type="radio" name="cxn_exam_opt2" value="' + escapeAttr(type) + '"><span><b class="pill-title">' + type + '</b><em class="pill-badge ok" data-badge="type">Freie Plätze</em></span></label>';
      }).join('');
    }
  }
  function stabilizeTypeBadges(rootEl){
    var selectedDate = rootEl.querySelector('input[name="cxn_exam_opt1"]:checked')?.value || '';
    rootEl.querySelectorAll('#cxn-exam-type label').forEach(function(label){
      var input = label.querySelector('input[name="cxn_exam_opt2"]');
      var badge = label.querySelector('em.pill-badge');
      if(!input || !badge) return;
      var ok = selectedDate ? anyAvailableForType(selectedDate, input.value) : true;
      badge.textContent = ok ? 'Freie Plätze' : 'Ausgebucht';
      badge.classList.toggle('ok', ok);
      badge.classList.toggle('sold', !ok);
      label.classList.toggle('is-disabled', !ok);
      if(selectedDate) input.disabled = !ok;
    });
  }
  function renderDates(){
    var rootEl = root();
    if(rendering || !rootEl || !variants.length) return;
    rendering = true;
    ensureHolder(rootEl);
    var area = ui(rootEl);
    if(area){
      var stale = area.querySelector('#exam-no-variants-msg');
      if(stale) stale.remove();
    }
    var dateFS = ensureDateField(rootEl);
    ensureTypeField(rootEl);
    var group = dateFS && dateFS.querySelector('[data-exam-opt="1"]');
    if(group){
      var previous = rootEl.querySelector('input[name="cxn_exam_opt1"]:checked')?.value || '';
      var dates = filteredDates(rootEl);
      group.innerHTML = dates.map(function(date){
        var ok = anyAvailableOnDate(date);
        var checked = previous === date ? 'checked' : '';
        return '<label class="cxn-pill ' + (ok ? '' : 'is-disabled') + '"><input type="radio" name="cxn_exam_opt1" value="' + escapeAttr(date) + '" ' + checked + ' ' + (ok ? '' : 'disabled') + '><span><b class="pill-title">' + date + '</b><em class="pill-badge ' + (ok ? 'ok' : 'sold') + '">' + (ok ? 'Freie Plätze' : 'Ausgebucht') + '</em></span></label>';
      }).join('') || '<p class="cxn-alert" style="margin:0">Keine passenden Prüfungstermine gefunden.</p>';
      dateFS.setAttribute(DATE_MARKER, '1');
      var toggle = dateFS.querySelector('.cxn-toggle');
      if(toggle && !toggle.__codexB1Toggle){
        toggle.__codexB1Toggle = true;
        toggle.addEventListener('click', function(){
          var box = dateFS.querySelector('.cxn-collapsible');
          var collapsed = !box || box.getAttribute('data-collapsed') !== 'false';
          if(box){ box.setAttribute('data-collapsed', collapsed ? 'false' : 'true'); box.style.maxHeight = collapsed ? 'none' : '245px'; }
          toggle.textContent = collapsed ? '- Weniger anzeigen' : '+ Mehr anzeigen';
        });
      }
    }
    stabilizeTypeBadges(rootEl);
    setTimeout(function(){ rendering = false; }, 0);
  }
  function schedule(delay){
    clearTimeout(scheduled);
    scheduled = setTimeout(renderDates, delay || 0);
  }
  function init(){
    var rootEl = root();
    if(!rootEl){ setTimeout(init, 150); return; }
    fetch('/products/' + EXAM_HANDLE + '.js').then(function(res){ return res.ok ? res.json() : null; }).then(function(product){
      if(!product) return;
      variants = (product.variants || []).map(function(v){ return { id:v.id, title:v.title, option1:v.option1, option2:v.option2, available:v.available, price:v.price }; });
      [0, 500, 1200, 2500, 4500, 7000].forEach(function(delay){ setTimeout(renderDates, delay); });
      var area = ui(rootEl);
      if(area){
        new MutationObserver(function(){ if(!rendering && variants.length) schedule(60); }).observe(area, { childList: true, subtree: true });
      }
    }).catch(function(){});
    rootEl.addEventListener('change', function(event){
      var name = event.target && event.target.name;
      if(name === 'cxn_course_variant' || name === 'cxn_package' || name === 'cxn_exam_opt2') schedule(0);
      if(name === 'cxn_exam_opt1') stabilizeTypeBadges(rootEl);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

(function(){
  var TARGET = '/collections/telc-prufungen';

  function isTelcExamMenuLink(link){
    if(!link || !link.matches('a')) return false;
    var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
    return text === 'telc Prüfungen' && link.getAttribute('href') === TARGET;
  }

  document.addEventListener('click', function(event){
    var link = event.target && event.target.closest && event.target.closest('a');
    if(!isTelcExamMenuLink(link)) return;
    if(event.target.closest('[data-toggle-menu-mb]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = TARGET;
  }, true);
})();
